module.exports = __webpack_public_path__ + "res/4-img_info_t.10027ac47d5b5d2651c332fdcb6c1a85.png";